module.exports = __webpack_public_path__ + "img/pro_three_6.68729473.jpg";